export default __webpack_public_path__ + "static/media/check-shadow.70f462b7.svg";